import { GrowthBook } from '@growthbook/growthbook-react';
import { DEFAULT_GROWTHBOOK_FEATURES } from '../growthbook-constants';
const growthbook = new GrowthBook({
  apiHost: process.env.NEXT_PUBLIC_GROWTHBOOK_HOST,
  clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_SECRET,
  enableDevMode: true
});
const host = `${process.env.NEXT_PUBLIC_GROWTHBOOK_HOST}`;
const secret = `${process.env.NEXT_PUBLIC_GROWTHBOOK_SECRET}`;

const loadFeatures = async () => {
  await growthbook.loadFeatures();
};

const getFeatureFlagValue = (key, defaultValue) => {
  if (typeof defaultValue === 'boolean') {
    return growthbook.isOn(key);
  } else {
    return growthbook.getFeatureValue(key, defaultValue);
  }
};

const fetchAllFeatureFlags = async () => {
  await loadFeatures();
  const featureKeys = DEFAULT_GROWTHBOOK_FEATURES;

  const featureValues = {};
  Object.entries(featureKeys).forEach(([key, defaultValue]) => {
    featureValues[key] = getFeatureFlagValue(key, defaultValue);
  });
  return featureValues;
};

export { fetchAllFeatureFlags, growthbook, loadFeatures };
